import React from 'react'

import { ReactComponent as InvoicesIcon } from '../../../static/images/invoices.svg'
import { usePageRightRail } from '../../ui/layout/pageRightRail/PageRightRailProvider'

import './styles.scss'
import Button, { ButtonVariant } from '../../ui/button'


const RecentInvoicesPanelTrigger: React.FC = () => {
  const { isOpen, toggle } = usePageRightRail()

  return (
    <>
      <Button
        className={isOpen ? 'recent-invoices-panel-trigger--open' : 'recent-invoices-panel-trigger--collapsed'}
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls='recent-invoices-panel'
        icon={<InvoicesIcon width={18} height={18} />}
        iconPosition='start'
        variant={ButtonVariant.PLAIN}
      >
        Recent Invoices
      </Button>
    </>
  )
}

export default RecentInvoicesPanelTrigger
